import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import Address from "../components/Address";
import Categories from "../components/Categories";
import FashionSection from "../components/FashionSection";
import FollowInstagram from "../components/FollowInstagram";
import LatestBlog from "../components/LatestBlog";
import LatestProducts from "../components/LatestProducts";
import OurProducts from "../components/OurProducts";
// import Collections from "../components/Collections";
import Slider from "../components/Slider";
import { Helmet } from "react-helmet";
const Home = () => {
  return (
    <div>
      <Helmet title="home" />
      <Slider />
      <Categories />
      <LatestProducts />
      <FashionSection />
      <OurProducts />
      <LatestBlog />
      <FollowInstagram />
      <Address />
    </div>
  );
};

export default Home;
